module.exports = __webpack_public_path__ + "./assets/img/macbook2.95a2e646.png";